const aggregationFunctionLegitimacy = {
    forbidden: 'Forbidden',
    possible: 'Possible',
    required: 'Required'
};

export default aggregationFunctionLegitimacy;
